import { createAction } from '@reduxjs/toolkit';

const getCases = createAction<{ travelerId: number; placementId?: string; status?: string }>('GET_SUPPORT_CASES');
const getCaseDetail = createAction<{ sfCaseId: string }>('GET_SUPPORT_CASE_DETAIL');

export const serviceActions = {
  getCases,
  getCaseDetail,
};
